export { default } from "./DesignConfig";
